import { reactive, readonly, toRefs } from 'vue'
import { httpInstance } from './http'

const state = reactive({
  clientData: {},
})

export function setClientData(data) {
  state.clientData = data
}

export const clientData = readonly(toRefs(state).clientData)

export function setClientDataValue(key, value) {
  state.clientData[key] = value
}

export async function saveClientData() {
  try {
    await httpInstance.post('clientData', {
      data: state.clientData,
    })
    return {
      success: true,
    }
  } catch (error) {
    console.error(error)
  }

  return {
    success: false,
  }
}
